import { motion } from "framer-motion";

export const MaskedLine = ({ children, delay = 0, inView = false, className = "" }) => (
  <motion.span
    className={`block overflow-hidden pb-[0.1em] -mb-[0.1em] ${className}`}
    initial="hidden"
    {...(inView
      ? { whileInView: "show", viewport: { once: true, margin: "-60px" } }
      : { animate: "show" })}
  >
    <motion.span
      className="block will-change-transform"
      variants={{ hidden: { y: "115%" }, show: { y: "0%" } }}
      transition={{ duration: 1, delay, ease: [0.16, 1, 0.3, 1] }}
    >
      {children}
    </motion.span>
  </motion.span>
);
